'use client';

import { postMergeCart } from '@/api/postMergeCart';
import ActionButton from '@/components/form/ActionButton/ActionButton';
import ContentPageTitle from '@/components/ui/ContentPageTitle/ContentPageTitle';
import { useGlobalLoadingAtom } from '@/state';
import layoutStyles from '@/styles/modules/layout.module.scss';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { useRouter } from 'next/navigation';
import { useLogin } from '../../hooks/useLogin';
import LoginForm from '../LoginForm/LoginForm';
import styles from './SignInForm.module.scss';

const SignInForm = ({
  callbackUrl = '/',
}: {
  callbackUrl: string;
}) => {
  const router = useRouter();
  const [, startGlobalLoading] = useGlobalLoadingAtom();
  const { login, isLoading } = useLogin(callbackUrl);

  const handleSignupClick = () => {
    startGlobalLoading();
    router.push(`/auth/signup?callbackUrl=${encodeURIComponent(callbackUrl)}`);
  };

  return (
    <div>
      {/* ログイン */}
      <ContentPageTitle title='ログイン' pcTextAlign='Center' spTextAlign='Center' />
      <div className={utilsStyles.mtSmall}>
        <LoginForm onSubmit={login} isLoading={isLoading} />
      </div>
      {/* 新規会員登録導線 */}
      <div className={styles.signupContainer}>
        <ContentPageTitle title='はじめてご利用の方' pcTextAlign='Center' spTextAlign='Center' />
        <div className={`${layoutStyles.centeredBtnWrapper} ${utilsStyles.mtSmall}`}>
          <ActionButton
            onClick={handleSignupClick}
            color='primary'
            bgColor='white'
            outlined={true}
            borderColor='gray300'
          >
            会員登録する
          </ActionButton>
        </div>
        <div className={`${utilsStyles.centeredVertical} ${styles.signupDescription}`}>
          <p className={utilsStyles.textSmall}>
            ※すでに「Butterfly ID」をお持ちで新規登録する方は、上の入力欄からログインください。
          </p>
        </div>
      </div>
    </div>
  );
};
export default SignInForm;
